import React from 'react';
import './css/footer.css';

function Footer() {
    return (
        <div className="footer">
            <div className={'column desktop'}>
                <div className={'column'}>
                    <img src="./images/icon-faces.png" className='app-logo' alt="Faces app"/>
                    <div className='company'>Wowmaking, LCC</div>
                </div>
            </div>

            <div className={'column mobile'}>
                <div className={'column store-buttons'}>
                    <img src="./images/app-store.png" className='' alt="App Store"/>
                    {/*<img src="./images/google-play.png" className='' alt="Google Play"/>*/}
                </div>
            </div>


            <div className={'column mobile-start'}>
                <div>Follow us:</div>
                <a className="oval" href={'https://www.instagram.com/facesios/'}>
                    <img src="./images/instagram.png" className='social-media-img' alt="Instagram"/>
                </a>
                <a className="oval" href={'https://www.facebook.com/Faces-2287416828250350/'}>
                    <img src="./images/facebook.png" className='social-media-img' alt="Facebook"/>
                </a>
                <a className="oval" href={'https://www.youtube.com/channel/UClyi2A2wA2_ZPpwVhheGDzQ'}>
                    <img src="./images/youtube.png" className='social-media-img' alt="Youtube"/>
                </a>
            </div>

            <div className={'links mobile-start'}>
                <a href={'https://wowmaking.net/faces-terms/'}>Privacy Policy</a>
                <a href={'https://wowmaking.net/en/policy/'}>Terms of Service</a>
            </div>

            <div className={'column mobile mobile-start'}>
                <div className={'column'}>
                    <img src="./images/icon-faces.png" className='app-logo' alt="Faces app"/>
                    <div className='company'>Wowmaking, LCC</div>
                </div>
            </div>
        </div>
    );
}

export default Footer;
